import React, { useState } from 'react';
import { BsPencilSquare, BsJournal, BsX, BsCheckCircle, BsArrowUp, BsArrowDown } from 'react-icons/bs';
import styles from '../../HedefFormu.module.css';

const YayinlarCard = ({ data, onEdit, academic = { name: '', department: '' } }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  
  const totalQ = data.q1 + data.q2 + data.q3 + data.q4;
  const totalPublications = totalQ + data.esci + data.uluslararasiAlanIndeks + data.trDizin;
  
  const TARGET = {
    total: 25,
    wos: 15,
    q1: 5,
    q2: 4,
    q3: 3,
    q4: 3,
    esci: 4,
    uluslararasi: 3,
    trDizin: 3
  };
  
  const completionStatus = {
    q1: data.q1 >= TARGET.q1,
    q2: data.q2 >= TARGET.q2,
    q3: data.q3 >= TARGET.q3,
    q4: data.q4 >= TARGET.q4,
    esci: data.esci >= TARGET.esci,
    uluslararasi: data.uluslararasiAlanIndeks >= TARGET.uluslararasi,
    trDizin: data.trDizin >= TARGET.trDizin
  };

  const wosPercentage = Math.min((totalQ / TARGET.wos) * 100, 100);
  const totalPercentage = Math.min((totalPublications / TARGET.total) * 100, 100);

  const handleEdit = () => {
    setShowEditModal(true);
  };

  return (
    <>
      {academic?.name && (
        <div className={styles.academicInfo}>
          <div className={styles.academicName}>{academic.name}</div>
          <div className={styles.academicDepartment}>{academic.department}</div>
        </div>
      )}

      <div className={styles.card} data-type="yayinlar">
        <div className={styles.cardHeader}>
          <h3 className={styles.cardTitle}>
            <BsJournal className={styles.cardIcon} />
            Yayınlar
          </h3>
          <div className={styles.cardActions}>
            <button 
              className={styles.actionButton}
              onClick={handleEdit}
              aria-label="Yayınları düzenle"
            >
              <BsPencilSquare />
            </button>
          </div>
        </div>

        <div className={styles.formSection}>
            <h4 className={styles.formTitle}>Q1, Q2, Q3, Q4 Yayınlar</h4>
            <div className={styles.statRow}>
                <span className={styles.statLabel}>
                Q1
                {completionStatus.q1 && <BsCheckCircle className={styles.targetComplete} />}
                <span className={styles.targetInfo}>(Hedef: {TARGET.q1})</span>
                </span>
                <div className={styles.statValue}>{data.q1}</div>
            </div>
            <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Q2
              {completionStatus.q2 && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.q2})</span>
            </span>
            <div className={styles.statValue}>{data.q2}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Q3
              {completionStatus.q3 && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.q3})</span>
            </span>
            <div className={styles.statValue}>{data.q3}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Q4
              {completionStatus.q4 && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.q4})</span>
            </span>
            <div className={styles.statValue}>{data.q4}</div>
          </div>

            <div className={styles.targetStatus}>
                <div className={styles.targetItem}>
                    <span>Toplam Q1, Q2, Q3, Q4 Yayın</span>
                    <span className={(data.q1 + data.q2 + data.q3 + data.q4) >= (TARGET.q1 + TARGET.q2 + TARGET.q3 + TARGET.q4) ? styles.targetComplete : styles.targetIncomplete}>
                        {data.esci + data.uluslararasiAlanIndeks + data.trDizin} / {TARGET.esci + TARGET.uluslararasi + TARGET.trDizin}
                    </span>
                </div>
            </div>
        </div>

        <div className={styles.formSection}>
            <h4 className={styles.formTitle}>Diğer Yayınlar</h4>

            <div className={styles.statRow}>
            <span className={styles.statLabel}>
              ESCI
              {completionStatus.esci && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.esci})</span>
            </span>
            <div className={styles.statValue}>{data.esci}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Alan İndeksi
              {completionStatus.uluslararasi && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasi})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiAlanIndeks}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              TR-Dizin
              {completionStatus.trDizin && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.trDizin})</span>
            </span>
            <div className={styles.statValue}>{data.trDizin}</div>
          </div>

          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={(data.esci + data.uluslararasiAlanIndeks + data.trDizin) >= (TARGET.esci + TARGET.uluslararasi + TARGET.trDizin) ? styles.targetComplete : styles.targetIncomplete}>
                {data.esci + data.uluslararasiAlanIndeks + data.trDizin} / {TARGET.esci + TARGET.uluslararasi + TARGET.trDizin}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.totalSection}>
          <div className={styles.totalRow}>
            <span>Toplam Q1, Q2, Q3, Q4 Yayın</span>
            <div>{totalQ} / {TARGET.wos}</div>
          </div>
          <div className={styles.totalRow}>
            <span>Toplam Diğer Yayın</span>
            <div>{data.esci + data.uluslararasiAlanIndeks + data.trDizin} / {TARGET.esci + TARGET.uluslararasi + TARGET.trDizin}</div>
          </div>
          <div className={styles.totalRow} style={{ marginTop: '12px', fontWeight: 'bold' }}>
            <span>Toplam Yayın</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {totalPublications} / {TARGET.total}
              <span className={totalPublications >= TARGET.total ? styles.trendUp : styles.trendDown}>
                {totalPublications >= TARGET.total ? <BsArrowUp /> : <BsArrowDown />}
                {Math.abs(TARGET.total - totalPublications)}
              </span>
            </div>
          </div>

          <div className={styles.progressBar}>
            <div 
              className={styles.progressFill} 
              style={{ width: `${totalPercentage}%` }}
            />
            <span className={styles.progressLabel}>{`${totalPercentage.toFixed(1)}% (Hedef: ${TARGET.total})`}</span>
          </div>
        </div>
      </div>

      {showEditModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} data-type="yayinlar">
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>
                <BsJournal /> Yayın Hedeflerini Düzenle
              </h2>
              <button 
                className={styles.actionButton}
                onClick={() => setShowEditModal(false)}
                aria-label="Kapat"
              >
                <BsX size={24} />
              </button>
            </div>
            
            <form className={styles.modalForm}>
              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Q1, Q2, Q3, Q4 Yayınlar</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde SCIE, SSCI veya AHCI kapsamındaki dergilerde yayınlanması planlanan özgün araştırma makalelerinin dergi etki dilimlerine göre sayılarını belirtiniz.
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Q1 Yayın Sayısı (Hedef: {TARGET.q1})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.q1}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Q2 Yayın Sayısı (Hedef: {TARGET.q2})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.q2}
                      min="0"
                    />
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Q3 Yayın Sayısı (Hedef: {TARGET.q3})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.q3}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Q4 Yayın Sayısı (Hedef: {TARGET.q4})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.q4}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Diğer Yayınlar</h3>
                <p className={styles.detailsLabel}>
                  2025 yılı içerisinde SCIE, SSCI veya AHCI dışında hakemli dergilerde yayınlanmasını planladığınız makaleler (*Üniversitelerarası Kurulun Belirlediği Alan Endeksleri*)
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>ESCI Yayın Sayısı (Hedef: {TARGET.esci})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.esci}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Alan İndeksi (Hedef: {TARGET.uluslararasi})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiAlanIndeks}
                      min="0"
                    />
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>TR-Dizin (Hedef: {TARGET.trDizin})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.trDizin}
                      min="0"
                    />
                  </div>
                </div>
              </div>
            </form>

            <div className={styles.buttonContainer}>
              <button 
                className={styles.cancelButton}
                onClick={() => setShowEditModal(false)}
              >
                İptal
              </button>
              <button className={styles.saveButton}>
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default YayinlarCard; 